// Libs
import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
// App
import { ProductDetails } from 'app-shared/lib/api/catalog/product';
import { getShopById as getShopAPI, ShopDetails } from 'app-shared/lib/api/catalog/shop';
import { getProductById as getProductAPI } from 'app-shared/lib/api/catalog/product';
import { BagSliceState } from './bag.slice.interfaces';

export const getShop = createAsyncThunk(
  'bag/getShop',
  async (id: number): Promise<ShopDetails> => {
    const { data } = await getShopAPI(id);

    return data;
  }
);

export const getProduct = createAsyncThunk(
  'bag/getProduct',
  async (id: number): Promise<ProductDetails> => {
    const { data } = await getProductAPI(id);

    return data;
  }
);

export const extraReducers = (builder: ActionReducerMapBuilder<BagSliceState>): void => {
  // Get shop
  builder.addCase(getShop.pending, (state: BagSliceState) => {
    state.isLoading = true;
  });
  builder.addCase(getShop.fulfilled, (state: BagSliceState) => {
    state.isLoading = false;
  });
  builder.addCase(getShop.rejected, (state: BagSliceState) => {
    state.isLoading = false;
  });

  // Get product
  builder.addCase(getProduct.pending, (state: BagSliceState) => {
    state.isLoading = true;
  });
  builder.addCase(getProduct.fulfilled, (state: BagSliceState) => {
    state.isLoading = false;
  });
  builder.addCase(getProduct.rejected, (state: BagSliceState) => {
    state.isLoading = false;
  });
};
